import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStyles, appActionsTheme, listSummaryHeaderTheme, mainHeaderTheme, mainTheme, footerTheme } from "./styles";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Grid, Paper, MuiThemeProvider } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { Panel } from "../../../panel";
import { LoginResource } from "@ploy-lib/rest-resources";
import { useResource } from "@rest-hooks/core";
import FormStatus from "../../../components/FormStatus";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true,
        minHeight: true,
        maxWidth: true,
        desktopViewForMobile: true
    }
};
const panelSettings = {
    header: {},
    summaryHeader: {
        defaultOptions: {
            literal: true
        }
    },
    mainHeader: {},
    main: mainPanelSettings,
    mainPost: {},
    actions: {},
    appActions: {},
    footer: {}
};
addRegisteredLayout({
    name: "List",
    displayName: "List",
    panels: panelSettings,
    hideFunctionButtons: true,
    showFormStatus: true
});
addRegisteredLayout({
    name: "CenteredList",
    displayName: "CenteredList",
    panels: panelSettings,
    hideFunctionButtons: true,
    showFormStatus: true
});
export const List = (props) => {
    const { panels, hideFunctionButtons, centered, showFormStatus } = props;
    const classes = useStyles(props);
    const login = useResource(LoginResource.status(), {});
    const { header, summaryHeader, mainHeader, main, mainPost, actions, appActions, footer } = panels;
    return (_jsxs(Grid, { container: true, spacing: 3, justifyContent: centered ? "center" : undefined, children: [header.sections.length > 0 && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(Panel, { transparent: true, fullWidth: true, justifyContent: "flex-end", ...header }) })), !login.isInternal && !hideFunctionButtons && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(ThemeProvider, { theme: appActionsTheme, children: _jsx(Panel, { transparent: true, fullWidth: true, ...appActions, justifyContent: "flex-end" }) }) })), summaryHeader.sections.length > 0 && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(Paper, { elevation: 0, children: _jsx(MuiThemeProvider, { theme: listSummaryHeaderTheme, children: _jsx(Panel, { fullWidth: true, className: classes.summaryHeader, ...summaryHeader }) }) }) })), mainHeader.sections.length > 0 && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(MuiThemeProvider, { theme: mainHeaderTheme, children: _jsx(Panel, { ...mainHeader }) }) })), main.sections.length > 0 && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(MuiThemeProvider, { theme: mainTheme, children: _jsx(Panel, { ...main }) }) })), (showFormStatus || actions || mainPost) && (_jsxs(Grid, { item: true, xs: 12, md: 8, children: [mainPost.sections.length > 0 && _jsx(Panel, { transparent: true, ...mainPost }), showFormStatus && (_jsx(FormStatus, { className: classes.errorSection, elevation: 0 })), actions && (_jsx(Panel, { transparent: true, justifyContent: "center", ...actions }))] })), footer && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(MuiThemeProvider, { theme: footerTheme, children: _jsx(Panel, { transparent: true, fullWidth: true, justifyContent: "flex-end", ...footer }) }) }))] }));
};
export const CenteredList = (props) => (_jsx(List, { ...props, centered: true }));
//# sourceMappingURL=List.js.map